export const dncType = {
  GET_DNC_LIST: "GET_DNC_LIST",
  GET_DNC_LIST_COUNT: "GET_DNC_LIST_COUNT",
};
